import React, { useEffect, useState } from 'react';
import './style/EditServicePage.css';

function EditServiceModal({ serviceId, onClose }) {
    const [serviceData, setServiceData] = useState(null);

    useEffect(() => {
        if (!serviceId) return;

        fetch(`http://localhost:8082/api/user-services/integ/${serviceId}`, {
            method: 'GET',
            headers: { 'User-Agent': 'insomnia/11.3.0' }
        })
            .then(res => {
                if (!res.ok) throw new Error('Ошибка загрузки сервиса');
                return res.json();
            })
            .then(data => setServiceData(data))
            .catch(err => console.error(err));
    }, [serviceId]);

    if (!serviceData) return <div className="modal-overlay"><div className="modal-content">Загрузка...</div></div>;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Редактирование сервиса</h2>
                <table className="info-table">
                    <tbody>
                    <tr><td>ID</td><td>{serviceData.id}</td></tr>
                    <tr><td>Service ID</td><td>{serviceData.service_id}</td></tr>
                    <tr>
                        <td>Название</td>
                        <td>
                            <input
                                type="text"
                                value={serviceData.service_name}
                                onChange={(e) => setServiceData({ ...serviceData, service_name: e.target.value })}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Всего</td>
                        <td>
                            <input
                                type="number"
                                value={serviceData.total_count}
                                onChange={(e) => setServiceData({ ...serviceData, total_count: e.target.value })}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>Осталось</td>
                        <td>
                            <input
                                type="number"
                                value={serviceData.remaining_count}
                                onChange={(e) => setServiceData({ ...serviceData, remaining_count: e.target.value })}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div className="edit-actions">
                    <button onClick={onClose}>Закрыть</button>
                    <button className="save-btn">Сохранить</button>
                </div>
            </div>
        </div>
    );
}

export default EditServiceModal;
